<div class="w-full">
  <!-- Equation Header with Toggle -->
  <div class="flex flex-nowrap justify-between items-center gap-6">
    <span class="text-muted-color shrink-0">{{ label }}</span>
    <div class="flex items-center gap-3">
      <button
        class="shrink-0 p-1 hover:bg-gray-100 rounded transition-colors duration-200 flex items-center gap-2"
        (click)="toggleCode()"
        type="button"
      >
        <lucide-icon
          size="16"
          *ngIf="!isCodeVisible"
          name="eye-off"
        ></lucide-icon>
        <lucide-icon size="16" *ngIf="isCodeVisible" name="eye"></lucide-icon>
      </button>
    </div>
  </div>

  <div
    class="transition-all duration-500 ease-in-out overflow-y-auto"
    [style.max-height]="isCodeVisible ? '250px' : '0'"
  >
    <div
      *ngIf="pythonCode?.length"
      class="w-full border-t border-gray-300 pt-2"
    >
      <pre
        class="language-python"
      ><code [innerHTML]="highlightedCode"></code></pre>
    </div>
  </div>
</div>
